import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'

import { RoomConfigurationSummaryCard } from './roomConfigurationSummaryCard'

export const RoomConfigurationSummary = () => {
	const roomConfigurations = useCartStore.use.roomConfigurations()

	return (
		<div
			className={cn(
				'flex flex-col gap-24',
				'md:grid md:grid-cols-2 md:items-start lg:grid-cols-3 xl:grid-cols-4'
			)}
		>
			{roomConfigurations.map((room, index) => (
				<RoomConfigurationSummaryCard key={index} {...room} roomIndex={index + 1} />
			))}
		</div>
	)
}
